import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

/** Content shown in the app-wide split panel (opened from a table row selection). */
export interface DetailPanel {
  header: string;
  body: ReactNode;
}

export interface SplitPanelApi {
  /** Show a detail panel, or pass null to close it. */
  show: (panel: DetailPanel | null) => void;
}

export const SplitPanelContext = createContext<SplitPanelApi>({ show: () => {} });

/** Access the app-wide split panel from any page. */
export const useSplitPanel = (): SplitPanelApi => useContext(SplitPanelContext);

export const SPLIT_PANEL_I18N = {
  preferencesTitle: 'Split panel preferences',
  preferencesPositionLabel: 'Split panel position',
  preferencesPositionDescription: 'Choose the default split panel position.',
  preferencesPositionSide: 'Side',
  preferencesPositionBottom: 'Bottom',
  preferencesConfirm: 'Confirm',
  preferencesCancel: 'Cancel',
  closeButtonAriaLabel: 'Close panel',
  openButtonAriaLabel: 'Open panel',
  resizeHandleAriaLabel: 'Resize panel',
} as const;
